import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Observable } from "rxjs";
import {
	CashPlusWidgetFacade,
	CashplusWidgetViewModel
} from "@modules/cashplus/ui/cashplus-widget/cashplus-widget.facade";

@Component({
	selector: "cashplus-widget",
	templateUrl: "./cashplus-widget.component.html",
	styleUrls: ["./cashplus-widget.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class CashplusWidgetComponent {
	public viewModel$: Observable<CashplusWidgetViewModel> = this.cashplusWidgetFacade.getViewModel$();
	public isLoading$: Observable<boolean> = this.cashplusWidgetFacade.isLoadingApi$;

	constructor(private readonly cashplusWidgetFacade: CashPlusWidgetFacade) {}

	// ToDo: skipped for MVP
	public showEarnedModal(): void {
		// route to modal
		// this.router.navigate();
	}

	public handleManageClick(): void {
		this.cashplusWidgetFacade.goToFiatWallet();
	}

	public reFetchAPI(): void {
		this.cashplusWidgetFacade.getResponseAPI();
	}
}
